import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import NotFound from '@/components/NotFound.vue';
import ErrorPage from '@/components/Error.vue';
import AccessDenied from '@/components/AccessDenied.vue';

import globals from '@/globals';

// Layouts
import Layout1 from '@/layout/Layout1.vue';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    component: Layout1,
    children: [{
      path: '',
      component: () => import('@/components/Home.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'administration',
      component: () => import('@/components/Administration.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'users',
      component: () => import('@/components/Users.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'parameters',
      component: () => import('@/components/Parameters.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'entities',
      component: () => import('@/components/Entities.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'activities',
      component: () => import('@/components/Activities.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'prestations',
      component: () => import('@/components/Prestations.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'messages',
      component: () => import('@/components/Messages.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'audits',
      component: () => import('@/components/Audits.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'approbation',
      component: () => import('@/components/Approbation.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'dashboardApproving',
      component: () => import('@/components/DashboardApproving.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'faq',
      component: () => import('@/components/Faq.vue'),
      meta: { requiresAuth: true },
    }, {
      path: 'api',
      component: () => import('@/components/Api.vue'),
      meta: { requiresAuth: true },
    }],
  }, {
    // 404 Not Found page
    path: '*',
    component: NotFound,
  }, {
    path: '/Error',
    component: ErrorPage,
  }, {
    path: '/AccessDenied',
    component: AccessDenied,
  }],
});

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen');
  if (splashScreen) {
    splashScreen.style.opacity = 0;
    setTimeout(() => splashScreen && splashScreen.parentNode && splashScreen.parentNode.removeChild(splashScreen), 300);
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading');

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10);
});

export default router;
